<template>
  <div id="index">
    <!--轮播图-->
    <div id="carousel">
      <main-carousel :content="swiperData" @change="swiperChange" height="400px"></main-carousel>
      <div id="carousel-right">
        <div id="big-title" v-if="FirstCenterNews">
          <a class="title" :href="`/#/index/news?id=${encodeURIComponent(FirstCenterNews.Id)}`">{{FirstCenterNews.Title}}</a>
          <span v-html="FirstCenterNews.Brief"></span>
        </div>
        <el-divider></el-divider>
        <div id="news-content">
          <div class="news-item" v-for="item in CenterNews.slice(1,5)">
            <div>
              <img class="point" src="../assets/point.svg">
              <a :href="`/#/index/news?id=${encodeURIComponent(item.Id)}`" class="normal-title">{{item.Title}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--研究动态-->
    <div id="news" class="center">
      <div class="title">
        <div class="blue-title">
        </div>
        <span>研究动态</span>
      </div>
      <div id="news-content">
        <div class="side">
          <div class="news-item" v-for="(item,index) in news.slice(0,5)" :key="index">
            <div>
              <img class="point" src="../assets/point.svg">
              <a :href="`/#/academic/trends/detail?id=${encodeURIComponent(item.Id)}`">{{item.Title}}</a>
            </div>
            <p class="date">{{item.AdminSetTime}}</p>
          </div>
        </div>
        <img id="dotted" src="@/assets/dotted.svg">
        <div class="side">
          <div class="news-item" v-for="(item,index) in news.slice(5,10)" :key="index">
            <div>
              <img class="point" src="../assets/point.svg">
              <a :href="`/#/academic/trends/detail?id=${encodeURIComponent(item.Id)}`">{{item.Title}}</a>
            </div>
            <p class="date">{{item.AdminSetTime}}</p>
          </div>
        </div>
      </div>
      <p class="more" @click="$router.push({name:'trends'})">更多>></p>
    </div>

    <!--观点摘要-->
    <div class="center" id="summary">
      <div class="title">
        <div class="blue-title">
        </div>
        <span>观点摘要</span>
      </div>
      <div id="content">
        <opinion-card v-for="(item,index) in summary" :key="index" :item="item"></opinion-card>
      </div>
      <p class="more" @click="$router.push({name:'opinion'})">更多>></p>
    </div>

    <div class="center">
      <div class="title">
        <div class="blue-title">
        </div>
        <span>研究成果</span>
      </div>

      <div id="book-content">
        <div class="half">
          <div class="black-title">
            <img src="@/assets/book.png" class="title-icon-34">
            <p>出版著作</p>
          </div>
          <div id="book">
            <img v-for="item in publish" :src="item.Cover" class="bookImg">
          </div>
          <p class="more" @click="$router.push({name:'publications'})">更多>></p>
        </div>

        <div class="half" id="right">
          <div class="half">
            <div class="black-title">
              <img src="../assets/paper.png" class="title-icon">
              <p>学术论文</p>
            </div>
            <div id="scroll">
              <div class="book-item" v-for="item in paper" @click="$router.push(`/studyResult/detail?id=${encodeURIComponent(item.Id)}&type=paper`)">
                <img class="point" src="../assets/point.svg">
                <p class="book-title" :title="item.Title + '--' + item.Author">{{item.Title}}--{{item.Author}}</p>
                <p class="summary-date">{{item.Date}}</p>
              </div>
            </div>
          </div>
          <div class="half">
            <div class="black-title">
              <img src="../assets/report.png" class="title-icon-26">
              <p>研究报告</p>
            </div>
            <div id="scroll">
              <div class="book-item" @click="$router.push(`/studyResult/detail?id=${encodeURIComponent(item.Id)}&type=report`)" v-for="(item,index) in research" :key="index">
                <img class="point" src="../assets/point.svg">
                <p class="book-title">{{item.Title}}--{{item.Author}}</p>
                <p class="summary-date">{{item.Date}}</p>
              </div>
            </div>
          </div>
          <p class="more" @click="$router.push({name:'researchReport'})">更多>></p>
        </div>
      </div>
    </div>

    <div class="center">
      <div class="title">
        <div class="blue-title">
        </div>
        <span>应急课堂</span>
      </div>
      <div id="class-content">
        <div class="half">
          <div class="black-title">
            <img src="../assets/video.png" class="title-icon">
            <p>在线微课</p>
          </div>
          <div id="video-content">
            <video-div v-for="(item,index) in videoData" :key="index" :cardData="item"></video-div>
          </div>
          <p class="more" @click="$router.push({name:'onlineClass'})">更多>></p>
        </div>
        <div class="half">
          <div class="black-title">
            <img src="../assets/box.png" class="title-icon">
            <p>应急常识</p>
          </div>

          <div id="knowledge">
            <div class="half">
              <div @click="$router.push(`/emrClass/knowledgeDetail?id=${encodeURIComponent(item.Id)}`)" class="knowledge-item" v-for="(item,index) in knowledge.slice(0,4)" :key="index">
                <img class="point" src="../assets/point.svg">
                <p class="book-title">{{item.Title}}</p>
                <p class="summary-date">{{item.Date}}</p>
              </div>
            </div>
            <div class="half">
              <div @click="$router.push(`/emrClass/knowledgeDetail?id=${encodeURIComponent(item.Id)}`)" class="knowledge-item" v-for="(item,index) in knowledge.slice(4,8)" :key="index">
                <img class="point" src="../assets/point.svg">
                <p class="book-title">{{item.Title}}</p>
                <p class="summary-date">{{item.Date}}</p>
              </div>
            </div>
          </div>
          <p class="more" @click="$router.push({name:'knowledge'})">更多>></p>
        </div>
      </div>
    </div>

    <div id="index-bottom">
      <suggest-div @click.native="$router.push({name:'suggest'})"></suggest-div>
      <download-div @click.native="$router.push({path:'/index/download'})"></download-div>
    </div>
  </div>
</template>

<script>
import mainCarousel from "@/components/index/mainCarousel";
import opinionCard from "@/components/academic/opinionCard";
import suggestDiv from "@/components/index/suggestdiv";
import downloadDiv from "@/components/index/download";
import videoDiv from "@/components/index/videoDiv";
import Api from "@/network.js";
export default {
  name: "index",
  components: {
    mainCarousel,
    opinionCard,
    suggestDiv,
    downloadDiv,
    videoDiv
  },
  async beforeRouteEnter(to, from, next) {
    let data = await Api.index.getIndexData();
    let HomeImages = [];
    if (data.HomeImages) {
      data.HomeImages.forEach(item => {
        HomeImages.push({
          imgSrc: item.Image,
          text: item.Title,
          id:item.Id
        });
      });
    }
    next(vm =>
      vm.setData({
        CenterNews: data.CenterNews || [],
        FirstCenterNews: data.CenterNews === null ? [] : data.CenterNews[0],
        summary: data.SummaryOfViews || [],
        publish: data.Publish || [],
        news: data.ResearchDhynamics || [],
        paper: data.AcademicPaper || [],
        research: data.ResearchReport || [],
        swiperData: HomeImages || [],
        videoData: data.Course || [],
        knowledge: data.CommonSense || []
      })
    );
  },
  data() {
    return {
      swiperData: [],
      CenterNews: [],
      FirstCenterNews: [],
      news: [],
      summary: [],
      publish: [],
      paper: [],
      research: [],
      knowledge: [],
      videoData: [],
      swiperIndex: 0
    };
  },
  methods: {
    swiperChange(index) {
      this.swiperIndex = index;
    },
    setData(obj) {
      // 将obj与this.data合并
      Object.assign(this.$data, obj);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin linkHover {
  color: $standard-blue;
  text-decoration: underline;
}

#index {
  .point {
    height: 5px;
    margin-right: 15px;
  }
  .center {
    width: 80%;
    margin-left: 10%;
    position: relative;
  }
  .title {
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 700;
    color: #0087d3;
    font-size: 24px;
    margin-bottom: 22px;
    margin-top: 32px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    .blue-title {
      width: 7px;
      height: 24px;
      background-color: #0087d3;
      border-radius: 1px;
      margin-right: 1%;
    }
  }
  .more {
    position: absolute;
    font-size: 20px;
    bottom: 0;
    right: 0;
    color: #0087d3;
    cursor: pointer;
    transition: .1s;
    &:hover {
      opacity: .8;
    }
  }
  .black-title {
    font-size: 20px;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .book-title {
    flex: 1;
    color: black;
    font-size: 16px;
    @include hideTextOverflow;
    &:hover {
      @include linkHover
    }
  }
  .date {
    color: rgba(0, 0, 0, 0.35);
    font-size: 20px;
    white-space: nowrap;
  }
  .summary-date {
    color: rgba(64, 35, 0, 0.35);
    margin: 4px 0;
  }
}

#carousel {
  margin-top: 40px;
  margin-left: 10%;
  width: 80%;
  display: flex;
  .mainCarousel {
    flex: 1;
  }
  #carousel-right {
    width: 30%;
    margin: 18px 0;
    padding-left: 29px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    #news-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    #big-title {
      min-height: 35%;
      span {
        font-size: 16px;
        color: #909399;
        line-height: 24px;
      }
    }
    .news-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 9px;
      font-size: 20px;
      div {
        width: 100%;
        display: flex;
        align-items: center;
      }
      a {
        @include hideTextOverflow;
        margin: 5px 0;
        &:hover {
          @include linkHover
        }
      }
    }
  }
}

#news {
  #news-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px 30px 10px;
    #dotted {
      opacity: 0.2;
      height: 170px;
    }
    .side {
      width: 42%;
    }
    .news-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2px;
      font-size: 20px;
      div {
        width: 65%;
        display: flex;
        align-items: center;
      }
      a {
        @include hideTextOverflow;
        margin: 5px 0;
        &:hover {
          @include linkHover
        }
      }
    }
  }
}

#summary {
  .opinionCard {
    margin: 15px 10px;
    width: calc(50% - 20px);
  }
  #content {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 30px;
  }
}

#book-content {
  display: flex;
  justify-content: space-between;
  .half {
    display: flex;
    flex-direction: column;
    width: 48%;
    position: relative;
  }
  #right {
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 30px;
  }
  #book {
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow: hidden;
  }
  .bookImg {
    width: 150px;
    height: 200px;
    margin: 0 10px;
  }
  #scroll {
    // 疑似需求要求；暂时改为overflow: auto;
    border-radius: 3px;
    padding: 0 10px;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.35);
    height: 200px;
    overflow-y: auto;
    .book-item {
      width: 99%;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin: 5% 0;
    }
  }
}

#class-content {
  display: flex;
  justify-content: space-between;
  #knowledge {
    display: flex;
    max-height: 150px;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 30px;
  }
  .half {
    display: flex;
    flex-direction: column;
    width: 48%;
    position: relative;
    padding-bottom: 30px;
  }
  .knowledge-item {
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: 5px 0;
  }
}
.title-icon {
  width: 30px;
  height: 30px;
  margin-right: 15px;
  opacity: 0.8;
}
.title-icon-26 {
  width: 26px;
  height: 26px;
  margin-right: 15px;
  opacity: 0.7;
}
.title-icon-34 {
  width: 34px;
  height: 34px;
  margin-right: 15px;
}

#index-bottom {
  display: flex;
  justify-content: space-around;
  margin-top: 60px;
  margin-bottom: 160px;
}
#suggestDiv {
  width: 700px;
  margin-left: 10%;
  margin-right: 20px;
  cursor: pointer;
  transition: .25s;
  &:hover {
    opacity: .9;
  }
}
#downloadDiv {
  width: 700px;
  margin-right: 10%;
  margin-left: 20px;
  cursor: pointer;
  transition: .25s;
  &:hover {
    opacity: .9;
  }
}
#video-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: hidden;
  .videoDiv {
    margin: 0 10px;
  }
}
</style>